<template>
  <div class="row" id="listDashboard">
    <h4 v-if="workspaces.length <= 0" class="ml-3 text-dark text-italic">Chưa được phân quyền Dashboard!</h4>
    <router-link v-for="(workspace, index) in workspaces" :key="workspace.id" :to="'/user/operating-center?workspaceId=' + workspace.id" target="_blank" class="col-lg-4 col-6 overflow-hidden" style="z-index: 0" :title="workspace.operatingCenterName">
      <!-- small box -->
      <div class="small-box" :class="bgClass[index % bgClass.length]">
        <div class="inner">
          <h3>Dashboard</h3>

          <p class="text-nowrap">{{ workspace.operatingCenterName }}</p>
        </div>
        <div class="icon">
          <i class="fas fa-chart-pie"></i>
        </div>
        <span class="small-box-footer">Truy cập <i class="fas fa-arrow-circle-right"></i></span>
      </div>
    </router-link>
  </div>

  <Loading :active="isLoading" class="text-center" color="#000000" loader="spinner"></Loading>
</template>

<script>
import {mapActions} from 'vuex';
import Loading from "vue3-loading-overlay";
import config from '@/config/prod.env';
export default {
  name: "TheDashboard",
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      workspaces: [],
      bgClass: ['bg-primary', 'bg-success', 'bg-danger', 'bg-info'],
      streamImageUrl: null,
    }
  },
  methods: {
    ...mapActions('header', ['setupHeader',]),
    ...mapActions('workspace', ['getWorkspaceByRoleIds']),
    setup() {
      //setup dynamic header
      let header = 'Dashboard';
      this.setupHeader({ header });    

      this.streamFileUrl = process.env.VUE_APP_STREAM_FILE_URL;
    },
    async getData() {
      this.isLoading = true;
      let user = JSON.parse(localStorage.getItem('login_info'));
      let roleIds = user.roleInfo.map(e => e.id);
      let rs = await this.getWorkspaceByRoleIds(roleIds);
      if(rs.isOk) {
        this.workspaces = rs.data.data;
        if(this.workspaces.length === 1) {
          window.open(`/user/operating-center?workspaceId=${this.workspaces[0].id}`, '_blank');
        }
      }
      this.isLoading = false;
    }
  },
  mounted() {
    this.setup();
    this.getData();
  },
  created() {
   
  }
};
</script>

<style>
  #listDashboard img {
    width: 10rem;
  }
</style>